import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Box, Typography, Button, Paper } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const RegistrationSuccess = () => {
  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ p: 5, mt: 8, textAlign: 'center' }}>
        <CheckCircleOutlineIcon sx={{ fontSize: 64, color: 'success.main', mb: 2 }} />
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
          You're all set!
        </Typography>
        <Typography variant="body1" color="textSecondary" sx={{ mb: 1 }}>
          Welcome to Salon Logic. Your subscription is active and your account is ready to use.
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 4 }}>
          Check your email for a confirmation from Stripe. If you have any questions,
          contact us at support@salonlogic.co.uk
        </Typography>
        <Button
          component={Link}
          to="/"
          variant="contained"
          size="large"
          sx={{ py: 1.5, px: 4 }}
        >
          Go to Login
        </Button>
      </Paper>
    </Container>
  );
};

export default RegistrationSuccess;